var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorBox mColorBox",style:({ backgroundImage: 'url(' + "" + _vm.bgurl + ')' })},[_c('div',{staticClass:"frosted-background"},[_vm._t("default",null,{"content":"colorBoxContent"})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb2b7e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/colorBox.vue
// module id = null
// module chunks = 